import axios from 'axios';

const baseUrl =
  process.env.REACT_APP_QCX_API_BASE_URL! +
  '/followup/report/processos-em-andamento';

export const generateProcessosEmAndamentoReport = async (
  token: string,
  unidadeId: string,
  tenantIds: string[],
  clientIds: string[],
  startDate: string,
  endDate: string
): Promise<string | null> => {
  const params = new URLSearchParams();
  params.set('tenantId', tenantIds.join(','));
  if (clientIds.length > 0) params.set('clientesId', clientIds.join(','));
  params.set('insertionDateRange', `${startDate};${endDate}`);

  try {
    const response = await axios.get(`${baseUrl}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        quickcomexTenant: unidadeId,
      },
      responseType: 'blob',
      validateStatus: () => true,
    });

    if (response.status === 200) {
      const file = new File([response.data], 'processos-em-andamento.xlsx', {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      a.click();
      return null;
    }
    return await response.data.text();
  } catch {
    return 'Erro ao gerar o relatório.';
  }
};
